import JobCard from "./job-card";

export default function JobList({ jobs, onJobClick }) {
  if (!jobs || jobs.length === 0) {
    return null;
  }

  return (
    <div className="job-list">
      {jobs.map((job) => (
        <JobCard key={job.id || job.external_id} job={job} onClick={() => onJobClick(job)} />
      ))}
    </div>
  );
}

